import {
    GET_CUSTOMER_INVOICES,
    GET_CUSTOMER_INVOICES_SUCCESS,
    GET_CUSTOMER_INVOICES_FAIL,
    GET_CUSTOMER_INVOICE_DETAIL,
    GET_CUSTOMER_INVOICE_DETAIL_SUCCESS,
    GET_CUSTOMER_INVOICE_DETAIL_FAIL,
    ADD_NEW_CUSTOMER_INVOICE,
    ADD_NEW_CUSTOMER_INVOICE_SUCCESS,
    ADD_NEW_CUSTOMER_INVOICE_FAIL,
    UPDATE_CUSTOMER_INVOICE,
    UPDATE_CUSTOMER_INVOICE_SUCCESS,
    UPDATE_CUSTOMER_INVOICE_FAIL,
    DELETE_CUSTOMER_INVOICE,
    DELETE_CUSTOMER_INVOICE_SUCCESS,
    DELETE_CUSTOMER_INVOICE_FAIL,
    ADD_NEW_PAYMENT,
    ADD_NEW_PAYMENT_SUCCESS,
    ADD_NEW_PAYMENT_FAIL,
} from "./actionTypes"

export const getCustomerInvoices = (params) => ({
    type: GET_CUSTOMER_INVOICES,
    payload: params,
})

export const getCustomerInvoicesSuccess = (invoices) => ({
    type: GET_CUSTOMER_INVOICES_SUCCESS,
    payload: invoices,
})

export const getCustomerInvoicesFail = (error) => ({
    type: GET_CUSTOMER_INVOICES_FAIL,
    payload: error,
})

export const getCustomerInvoiceDetail = (id) => ({
    type: GET_CUSTOMER_INVOICE_DETAIL,
    payload: id,
})

export const getCustomerInvoiceDetailSuccess = (invoice) => ({
    type: GET_CUSTOMER_INVOICE_DETAIL_SUCCESS,
    payload: invoice,
})

export const getCustomerInvoiceDetailFail = (error) => ({
    type: GET_CUSTOMER_INVOICE_DETAIL_FAIL,
    payload: error,
})

export const addNewCustomerInvoice = (invoice) => ({
    type: ADD_NEW_CUSTOMER_INVOICE,
    payload: invoice,
})

export const addNewCustomerInvoiceSuccess = (invoice) => ({
    type: ADD_NEW_CUSTOMER_INVOICE_SUCCESS,
    payload: invoice,
})

export const addNewCustomerInvoiceFail = (error) => ({
    type: ADD_NEW_CUSTOMER_INVOICE_FAIL,
    payload: error,
})

export const updateCustomerInvoice = (invoice) => ({
    type: UPDATE_CUSTOMER_INVOICE,
    payload: invoice,
})

export const updateCustomerInvoiceSuccess = (invoice) => ({
    type: UPDATE_CUSTOMER_INVOICE_SUCCESS,
    payload: invoice,
})

export const updateCustomerInvoiceFail = (error) => ({
    type: UPDATE_CUSTOMER_INVOICE_FAIL,
    payload: error,
})

export const deleteCustomerInvoice = (id) => ({
    type: DELETE_CUSTOMER_INVOICE,
    payload: id,
})

export const deleteCustomerInvoiceSuccess = (id) => ({
    type: DELETE_CUSTOMER_INVOICE_SUCCESS,
    payload: id,
})

export const deleteCustomerInvoiceFail = (error) => ({
    type: DELETE_CUSTOMER_INVOICE_FAIL,
    payload: error,
})

export const addNewPayment = (payment) => ({
    type: ADD_NEW_PAYMENT,
    payload: payment,
})

export const addNewPaymentSuccess = (payment) => ({
    type: ADD_NEW_PAYMENT_SUCCESS,
    payload: payment,
})

export const addNewPaymentFail = (error) => ({
    type: ADD_NEW_PAYMENT_FAIL,
    payload: error,
})
